<template>
  <div class='dashboard-container'>
    <div class='dashboard-header'>
      <div class='header-upper'>
        <h2>COMPENDIUM</h2>
        <div class='profile-btn'>
          <i class='fas fa-user-circle'></i>
          <i class='fas fa-chevron-down'></i>
        </div>
      </div>
      <div class='header-lower'>
        <span><router-link to='/dashboard'>My Team</router-link></span>
        <span class='far fa-chevron-double-right'></span>
        <span>{{event.name}}</span>
      </div>
      <div class='header-nav'>
        <div :class='currentRoute === "home" ? "selected": null'><router-link to='home'>Home</router-link></div>
        <div :class='currentRoute === "details" ? "selected": null'><router-link to='details'>Details</router-link></div>
        <div :class='currentRoute === "sessions" ? "selected": null'><router-link to='sessions'>Sessions</router-link></div>
        <div :class='currentRoute === "attendees" ? "selected": null'><router-link to='attendees'>Attendees</router-link></div>
        <div>Settings</div>
      </div>
    </div>
    <div class="body">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
export default {
  props: ["id"],
  data() {
    return {
      event: {
        start: null,
        end: null,
        name: null,
        sessions: []
      }
    };
  },
  methods: {
    getEvent: function() {
      return this.$store
        .dispatch("events/get", { id: this.id })
        .then(() => this.$store.getters["events/event"](this.id));
    }
  },
  computed: {
    currentRoute(){
      if (this.$route.path.includes('home')) return 'home'
      if (this.$route.path.includes('details')) return 'details'
      if (this.$route.path.includes('sessions')) return 'sessions'
      if (this.$route.path.includes('attendees')) return 'attendees'
    }
  },
  beforeMount: function() {
    this.getEvent(this.id).then(event => {
      this.event = event;
    });
  }
};
</script>

<style scoped lang='scss'>
.dashboard-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.dashboard-header {
  flex-shrink: 0;
  background: white;
  color: $primary;
  border-bottom: 1px solid $gray-4;
  border-top: 6px solid $secondary;

  .profile-btn {
    color: $punch;
    padding: 8px 16px;
    border-radius: 4px;
    box-shadow: 0 1px 5px hsla(0, 0%, 0%, 0.2);
    font-size: 2rem;
  }

  .header-upper {
    h2 {
      letter-spacing: 6px;
    }
    padding: 4px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .header-lower {
    margin-top: 16px;
    font-weight: 800;
    font-size: 2.2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    > span {
      margin: 0px 24px;
    }
  }
  .header-nav {
    margin-top: 48px;
    font-size: 1.2rem;
    font-weight: 800;
    display: flex;
    flex-direction: row;
    justify-content: center;
    > div {
      margin: 0px 30px;
      padding: 0px 24px;
    }
    > div:hover {
      color: $secondary;
      border-bottom: 6px solid $secondary;
    }
    .selected {
      border-bottom: 6px solid $secondary;
    }
    .selected a {
      color: $secondary !important;
    }
      
    a {
      text-decoration: none;
    }
    a:link {
      color: $primary;
    }
    a:visited {
      color: $primary;
    }
  }
}
.body {
  background: $gray-1;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  padding: 20px 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/event/index.vue